import React from "react";
import { Box, Grid, IconButton, Paper, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const sectionSx = {
  p: { xs: 2, md: 3 },
  borderRadius: 2,
  borderColor: "divider",
};

export const ScreenSampleShipmentBiobank = () => {
  const { t } = useTranslation();
  const { reference } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const handleBackClick = () => {
    if (reference) {
      navigate(`/sample-shipments/${encodeURIComponent(reference)}`, {
        state: location.state,
      });
      return;
    }

    navigate(-1);
  };

  return (
    <Grid item xs={12}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            minHeight: 48,
          }}>
          <IconButton
            aria-label="Back"
            onClick={handleBackClick}
            sx={{ position: "absolute", left: 0, color: "primary.main" }}>
            <ArrowBackIcon />
          </IconButton>
          <Typography
            variant="h5"
            sx={{
              color: "primary.main",
              flex: 1,
              fontWeight: 800,
              lineHeight: 1.2,
              px: { xs: 5, md: 24 },
              textAlign: "center",
              textTransform: "uppercase",
            }}>
            {t("sampleBiobanking", "Sample Biobanking")}
          </Typography>
        </Box>

        <Paper variant="outlined" sx={sectionSx}>
          <Typography
            variant="h6"
            sx={{ color: "primary.main", fontWeight: 700, lineHeight: 1.25 }}>
            {t("bioBanking", "Bio Banking")}
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {t("comingSoon", "Coming soon")}
          </Typography>
        </Paper>
      </Box>
    </Grid>
  );
};

export default ScreenSampleShipmentBiobank;
